import styled from 'styled-components'

export const ComparisonLayout = styled.div`
  color: #243746;
  h4 {
    margin: 12px 0;
    font-size: 19px;
  }
  .measurements {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin: 16px 0;
  }
  .measurement {
    flex: 1;
    min-width: 200px;
    padding: 14px 18px;
    border-radius: 10px;
    background: #fbeaf3;
    border-left: 4px solid #c6016b;
  }
  .measurement.current {
    background: #e8f3fa;
    border-color: #2d749c;
  }
  .measurement strong,
  .measurement span {
    display: block;
  }
  .measurement span {
    margin-top: 6px;
    font-size: 13px;
  }
  .methodology {
    border: 1px solid #ebd6a5;
    background: #fff9ec;
    border-radius: 10px;
    padding: 14px 18px;
    line-height: 1.6;
  }
  .methodology p {
    margin: 4px 0;
  }
  .guide {
    color: #526b7d;
    line-height: 1.6;
    font-size: 13px;
  }
  .skill {
    border: 1px solid #d9e6ef;
    border-radius: 12px;
    margin: 24px 0;
    overflow: hidden;
    box-shadow: 0 3px 9px #24374608;
  }
  .skill h5 {
    background: #edf5fa;
    color: #235b7c;
    border-left: 5px solid #2d749c;
    margin: 0;
    padding: 16px 20px;
    font-size: 18px;
  }
  .section {
    padding: 16px 20px;
  }
  .section + .section {
    border-top: 1px solid #d9e6ef;
    background: #fafcfd;
  }
  .section h6 {
    font-size: 13px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin: 0 0 12px;
    color: #526b7d;
  }
  .table-scroll {
    overflow-x: auto;
  }
  table {
    border-collapse: collapse;
    width: 100%;
    min-width: 460px;
    font-size: 14px;
  }
  th,
  td {
    padding: 12px 14px;
    border-bottom: 1px solid #e4edf3;
    text-align: center;
    font-variant-numeric: tabular-nums;
  }
  thead th {
    font-size: 13px;
    background: #eef2f5;
    color: #344d5f;
  }
  thead th:nth-child(2) {
    background: #fbeaf3;
    color: #a9005b;
  }
  thead th:nth-child(3) {
    background: #e8f3fa;
    color: #235b7c;
  }
  th:first-child {
    text-align: left;
    width: 43%;
  }
  tbody th {
    font-weight: 500;
  }
  tbody tr:nth-child(even) {
    background: #f5f8fb;
  }
  tbody tr.total {
    font-weight: 700;
    background: #edf5fa;
  }
  tbody tr.total th {
    font-weight: 700;
  }
  .dimension th {
    color: #526b7d;
    padding-left: 28px;
  }
  .delta {
    border-radius: 5px;
    display: inline-block;
    min-width: 40px;
    padding: 3px 7px;
    background: #e8eff5;
    color: #243746;
    font-weight: 600;
  }
  .downloads {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    padding: 16px 0;
  }
`
